import React, { useState } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import AdminHeader from './components/AdminHeader';
import SuperAdminDashboard from './SuperAdminDashboard';
import AdminDashboard from './AdminDashboard';
import { useTheme } from '../../contexts/ThemeContext';

// const ADMIN_EMAILS = new Set(['admin@netsmartz.com', 'superadmin@netsmartz.com']);

const AdminRoot = () => {
   // 'admin' | 'superadmin'
  const { token, user, loading } = useAuth();
  const { isDark, toggleTheme } = useTheme();

  const bg = isDark ? '#0a0f1e' : '#f8fafc';
  // const email = (user?.email || '').toLowerCase();
  // const isAdminUser = ADMIN_EMAILS.has(email);

  const { isAdmin } = useAuth();  
  const {isSuperAdmin} = useAuth();
  const isAdminUser = isAdmin;

  const [role, setRole] = useState(isSuperAdmin ? 'superadmin' : 'admin');

  if (loading) {
    return (
      <div
        className="flex h-screen items-center justify-center"
        style={{ background: bg }}
      >
        <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-[#F87217]" />
      </div>
    );
  }

  if (!isAdminUser) {
    return (
      <div
        className="flex h-screen items-center justify-center p-6"
        style={{ background: bg }}
      >
        <div
          className="max-w-xl w-full rounded-2xl p-6 border"
          style={{
            background: isDark ? '#0f1729' : '#ffffff',
            borderColor: isDark ? '#1e2d52' : '#e2e8f0',
            color: isDark ? '#c9d1d9' : '#334155',
          }}
        >
          <h2 className="text-lg font-semibold mb-2">Access denied</h2>
          <p className="text-sm opacity-90">
            Your account does not have admin portal access. Sign in with an admin-enabled account.
          </p>
          {!!email && (
            <p className="text-xs mt-3 opacity-70">
              Signed in as: {email}
            </p>
          )}
        </div>
      </div>
    );
  }

  return (
    <div
      className="flex h-screen overflow-hidden font-['Inter',sans-serif]"
      style={{ background: bg }}
    >
      {/* Main content */}
      <div className="flex-1 flex flex-col min-w-0 overflow-hidden">
        {/* Header */}
        <AdminHeader
          role={role}
          isDark={isDark}
          toggleDark={toggleTheme}
          onRoleSwitch={setRole}
          isSuperAdmin={isSuperAdmin}
        />

        {/* Dashboard content */}
        {role === 'superadmin' && isSuperAdmin ? (
  <SuperAdminDashboard isDark={isDark} token={token} />
) : (
  <AdminDashboard isDark={isDark} token={token} />
)}
      </div>
    </div>
  );
};

export default AdminRoot;